import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ArtistInfoPage from "./pages/ArtistInfoPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminDashboard from "./pages/AdminDashboard";
import QuestionnaireEditor from "./pages/QuestionnaireEditor";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/first-season-artist-info" replace />} />
            <Route path="/first-season-artist-info" element={<ArtistInfoPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/questionnaire" element={<ProtectedRoute adminOnly><QuestionnaireEditor /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/first-season-artist-info" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
